import { render, staticRenderFns } from "./SetIcon.vue?vue&type=template&id=8483c6d0"
import script from "./SetIcon.vue?vue&type=script&lang=js"
export * from "./SetIcon.vue?vue&type=script&lang=js"
import style0 from "./SetIcon.vue?vue&type=style&index=0&id=8483c6d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports